// import { Fragment, useEffect, useState, type ReactNode, useRef } from 'react';
// import { isSupported } from 'firebase/messaging';

// import './App.css';
// import { Routes } from './routes/routes';
// import Popup from './components/common/popup/Popup';
// import { useAppDispatch, useAppSelector } from './store/hooks';
// import { getProfile } from './store/profile/profile.slice';
// import { StorageUtils } from './utils';
// import PageLoader from './components/common/pageLoader/PageLoader';
// import { useForceCreateCompany, useGetIdentity, useListenToChatNotifications, useSignOut } from './hooks';
// import { getCompany } from './store/company/company.slice';
// import { userAuthorizationFailure } from './store/auth/auth.slice';
// import ErrorBoundary from './components/common/errorBoundary/ErrorBoundary';
// import useGetNotifications from './firebase/useGetNotifications';
// import { Helmet } from "react-helmet";
// import { InputField } from './components/common/formFields';
// import { componentSizeVariantsEnum } from './constants';
// import { EyeIcon, EyeOffIcon, PasswordIcon } from './components/common/common.icons';
// import { Button, ConfirmModal, Typography } from './components/common';
// import { assignModalId, resetConfirmModalId } from './store/common/common.slice';
// import InviteUser from './components/header/inviteUser/InviteUser';
// import { inviteUserModalId } from './components/cards/inviteNetwork';
// import { socketService } from './services/socket.api.service';
// // import { io } from 'socket.io-client';
// import { setChatCount, setNotificationCount } from './store/chat/chat.slice';
// import { useNavigate } from 'react-router-dom';
// import { start } from 'node:repl';
// const signOutModalId = 'sign-up-modal-id';
// const App = (): ReactNode => {
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();

//   useForceCreateCompany();
//   useGetNotifications();
//   useListenToChatNotifications();

//   const { isAuthorized, isAuthorizationCheckInProgress } = useAppSelector((store) => store.auth);
//   const { confirmModalId, modalId } = useAppSelector((store) => store.common);
//   const { chatCount } = useAppSelector((store) => store.chat);
//   const { getIdentities } = useGetIdentity();
//   const { loggedInUserType, authenticatedId } = getIdentities();
//   const signOut = useSignOut();
//   const tempPassword: string = StorageUtils.get('tempPassword');
//   const [hasAccess, setHasAccess] = useState(!!tempPassword);
//   const [password, setPassword] = useState('');
//   const [maskPassword, setMaskPassword] = useState<boolean>(true);
//   const staticPassword = 'CodeCastling'; // Replace with your desired static password
//   const isSignOutModalOpen = confirmModalId === signOutModalId;
//   const openInviteUserModal = modalId === inviteUserModalId;

//   // const socketUrl = process.env.REACT_APP_API_CHAT_SOCKET_ENDPOINT || '';
//   // console.log(socketUrl, 'socketUrl');
//   // const socketService = io(socketUrl, { transports: ['websocket'] });

//   useEffect(() => {
//     const userId = StorageUtils.get('userId') as unknown as string;
//     const companyId = StorageUtils.get('companyId') as unknown as string;
//     if (companyId) {
//       dispatch(getCompany({ id: companyId }));
//     }
//     if (userId) {
//       dispatch(getProfile({ id: userId }));
//     } else if (!companyId && !userId) {
//       dispatch(userAuthorizationFailure());
//     }
//   }, []);

//   const registerNotificationServiceWorker = () => {
//     isSupported()
//       .then((supported) => {
//         if (supported) {
//           if ('serviceWorker' in navigator) {
//             navigator.serviceWorker
//               .register('/firebase-messaging-sw.js')
//               .then((registration) => {
//                 console.log('Service Worker registered with scope:', registration.scope);
//               })
//               .catch((error) => {
//                 console.error('Service Worker registration failed:', error);
//               });
//           }
//         } else {
//           console.log(
//             'This browser does not support the APIs required for Firebase Cloud Messaging.'
//           );
//         }
//       })
//       .catch((error) => {
//         console.error('Error checking API support: ', error);
//       });
//   };

//   useEffect(() => {
//     registerNotificationServiceWorker();
//   }, []);

//   const handlePasswordSubmit = (e: any) => {
//     e.preventDefault();
//     if (password === staticPassword) {
//       setHasAccess(true);
//       StorageUtils.set('tempPassword', 'CodeCastling');
//     } else {
//       alert('Incorrect password!');
//     }
//   };
//   const closeSignOutModal = () => {
//     dispatch(resetConfirmModalId());
//   };
//   const handleSignOut = () => {
//     signOut();
//   };
//   const handleCloseInviteUserModal = () => {
//     dispatch(assignModalId(''));
//   };
//   // console.log(chatCount, 'chatCount');

//   // only for real time update
//   // useEffect(() => {
//   //   socketService.on("user-action-notification", (data) => {
//   //     console.log("Received action notification:", data);
//   //     const handleNotificationUnread = () => {
//   //       dispatch(setNotificationCount(10));
//   //     };
//   //     handleNotificationUnread();
//   //     alert(`Action: ${data.actionType} - ${data.message}`);
//   // });

//   // return () => {
//   //     socketService.off("user-action-notification");
//   // };
//   // }, []);

//   // previous checking after every 5 second
//   // useEffect(() => {
//   //   if (authenticatedId && loggedInUserType) {
//   //     const handleNotificationUnread = (data) => {
//   //       dispatch(setNotificationCount(data.count));
//   //     };
//   //     try {
//   //       socketService.connect();
//   //       socketService.on("connect", () => {
//   //         socketService.emit("join", { userId: authenticatedId });
//   //         socketService.on("joined-room", (data) => {
//   //           console.log("Joined confirmation:", data);
//   //         });

//   //         // Function to emit the event
//   //         const emitNotificationUnread = () => {
//   //           socketService.emit("notifications-unread", {
//   //             userId: authenticatedId,
//   //             userType: loggedInUserType
//   //           });
//   //           socketService.on("notifications-unread", handleNotificationUnread);
//   //         };

//   //         // Emit immediately once
//   //         emitNotificationUnread();

//   //         // Set an interval to emit every 5 seconds
//   //         const intervalId = setInterval(emitNotificationUnread, 5000);

//   //         const handleIdeaConversation = (data) => {
//   //           console.log(`Received message in ${authenticatedId}:`, data);
//   //         };

//   //         socketService.on("idea-conversation", handleIdeaConversation);

//   //         socketService.on("connect_error", (err) => {
//   //           console.error("Connection Error:", err);
//   //         });

//   //         // Cleanup when component unmounts
//   //         return () => {
//   //           clearInterval(intervalId);
//   //           socketService.off("notifications-unread", handleNotificationUnread);
//   //           socketService.off("idea-conversation", handleIdeaConversation);
//   //           socketService.off("connect_error");
//   //           socketService.disconnect();
//   //         };
//   //       });
//   //     } catch (err) {
//   //       console.log(err, "errorData");
//   //     }
//   //   }
//   // }, [authenticatedId, loggedInUserType]);

//   const handlerRef = useRef(null);

//   // useEffect(() => {
//   //   if (!authenticatedId || !loggedInUserType) return;
//   //   console.log("start socket")
//   //   const handleChatCount = (data) => {
//   //     console.log("chat count ...", data.unreadUsersCount);
//   //     dispatch(setChatCount(data.unreadUsersCount));
//   //   };

//   //   handlerRef.current = handleChatCount;

//   //   socketService.on("count-unread-chats", handlerRef.current);

//   //   const cleanup = () => {
//   //     setTimeout(() => {
//   //       socketService.off("count-unread-chats", handlerRef.current);
//   //     }, 100); // Small delay to allow the event to finish processing
//   //   };

//   //   return cleanup;
//   // }, [authenticatedId, loggedInUserType, dispatch]);

//   // useEffect(() => {
//   //   console.log("----------------------------------------------------------------------check-------------------------------")
//   //   socketService.on("count-unread-chats", (data) => {
//   //     console.log("chat count ...", data.unreadUsersCount);
//   //     dispatch(setChatCount(data.unreadUsersCount));
//   //   });
//   // }, [])

//   // const startSocket = async () => {
//   //   useEffect(() => {
//   //     console.log("start socket 101----------------------102----------------103")
//   //     if (!authenticatedId || !loggedInUserType) return;
//   //     console.log(socketService, 'socketService');

//   //     const handleNotificationUnread = (data) => {
//   //       dispatch(setNotificationCount(data.count));
//   //     };

//   //     const handleUserActionNotification = (data) => {
//   //       console.log("Received action notification:", data);
//   //       dispatch(setNotificationCount((prevCount) => prevCount + 1)); // Increment unread count dynamically
//   //       // alert(`Action: ${data.actionType} - ${data.message}`);
//   //     };

//   //     const handleChatCount = (data) => {
//   //       console.log("chat count ...  //     const handleIncreaseCount = (data) => {
//   //       console.log("Received action notification:", data);
//   //       dispatch(setChatCount((prevCount) => prevCount + 1)); // Increment unread count dynamically
//   //       // alert(`Action: ${data.actionType} - ${data.message}`);
//   //     };", data.unreadUsersCount)
//   //       if (data) {
//   //         socketService.off("count-unread-chats", handleChatCount);
//   //       }
//   //       dispatch(setChatCount(data.unreadUsersCount))
//   //     }
//   //     try {
//   //       // if (!socketService.connected) {
//   //       //   socketService.connect();
//   //       // }
//   //       socketService.on("connect", () => {
//   //         socketService.emit("join", { userId: authenticatedId });

//   //         socketService.on("joined-room", (data) => {
//   //           console.log("Joined confirmation:", data);
//   //         });
//   //         // Emit the unread notifications request
//   //         const emitNotificationUnread = () => {
//   //           socketService.emit("notifications-unread", {
//   //             userId: authenticatedId,
//   //             userType: loggedInUserType
//   //           });
//   //           socketService.emit("count-unread-users", {
//   //             userId: authenticatedId,
//   //             userType: loggedInUserType
//   //           });
//   //         };
//   //         // Listen to real-time notification updates
//   //         socketService.on("increaseUnreadCount", handleIncreaseCount);
//   //         socketService.on("count-unread-chats", handleChatCount)
//   //         socketService.on("notifications-unread", handleNotificationUnread);
//   //         socketService.on("user-action-notification", handleUserActionNotification);
//   //         // Emit immediately once
//   //         emitNotificationUnread();
//   //         // Set an interval to emit every 5 seconds
//   //         const intervalId = setInterval(emitNotificationUnread, 5000);
//   //         // Cleanup function to remove listeners
//   //         return () => {
//   //           clearInterval(intervalId);
//   //           socketService.off("notifications-unread");
//   //           socketService.off("increaseUnreadCount");
//   //           socketService.off("user-action-notification");
//   //           socketService.off("count-unread-chats", handleChatCount);
//   //           // socketService.disconnect();
//   //         };
//   //       });
//   //       socketService.on("connect_error", (err) => {
//   //         console.error("Connection Error:", err);
//   //       });
//   //     } catch (err) {
//   //       console.log(err, "errorData");
//   //     }
//   //   }, [authenticatedId, loggedInUserType, dispatch]);
//   // };
//   // startSocket();
//   // combined both every 5 sec and real time update

//   //   useEffect(() => {
//   //     console.log("start socket 101----------------------102----------------103");

//   //     if (!authenticatedId || !loggedInUserType) return;
//   //     console.log(socketService, "socketService");

//   //     const handleNotificationUnread = (data) => {
//   //         dispatch(setNotificationCount(data.count));
//   //     };

//   //     const handleUserActionNotification = (data) => {
//   //         console.log("Received action notification:", data);
//   //         dispatch(setNotificationCount((prevCount) => prevCount + 1));
//   //     };

//   //     const handleIncreaseCount = (data) => {
//   //         console.log("Received action notification:", data);
//   //         dispatch(setChatCount((prevCount) => prevCount + 1));
//   //     };

//   //     const handleChatCount = (data) => {
//   //         console.log("chat count ...", data.unreadUsersCount);
//   //         dispatch(setChatCount(data.unreadUsersCount));
//   //     };

//   //     // Emit the unread notifications request
//   //     const emitNotificationUnread = () => {
//   //         socketService.emit("notifications-unread", {
//   //             userId: authenticatedId,
//   //             userType: loggedInUserType
//   //         });
//   //         socketService.emit("count-unread-users", {
//   //             userId: authenticatedId,
//   //             userType: loggedInUserType
//   //         });
//   //     };

//   //     // Listen to real-time notification updates
//   //     socketService.on("increaseUnreadCount", handleIncreaseCount);
//   //     socketService.on("count-unread-chats", handleChatCount);
//   //     socketService.on("notifications-unread", handleNotificationUnread);
//   //     socketService.on("user-action-notification", handleUserActionNotification);

//   //     // Emit immediately once
//   //     emitNotificationUnread();
//   //     // Set an interval to emit every 50 seconds
//   //     const intervalId = setInterval(emitNotificationUnread, 50000);

//   //     // Cleanup function (only clearing interval)
//   //     return () => {
//   //         clearInterval(intervalId);
//   //     };
//   // }, [authenticatedId, loggedInUserType, dispatch]);

//   // useEffect(() => {
//   //   console.log("start socket 101----------------------102----------------103")
//   //   // dispatch(setChatCount(4))
//   //   // dispatch(setNotificationCount(5))
//   //   if (!authenticatedId || !loggedInUserType) return;
//   //   console.log(socketService, 'socketService');

//   //   const handleNotificationUnread = (data) => {
//   //     dispatch(setNotificationCount(data.count));
//   //   };

//   //   const handleUserActionNotification = (data) => {
//   //     console.log("Received action notification:", data);
//   //     dispatch(setNotificationCount((prevCount) => prevCount + 1)); // Increment unread count dynamically
//   //     // alert(`Action: ${data.actionType} - ${data.message}`);
//   //   };
//   //   const handleIncreaseCount = (data) => {
//   //     console.log("Received action notification:", data);
//   //     dispatch(setChatCount((prevCount) => prevCount + 1)); // Increment unread count dynamically
//   //     // alert(`Action: ${data.actionType} - ${data.message}`);
//   //   };
//   //   const handleChatCount = (data) => {
//   //     console.log("chat count ...", data.unreadUsersCount)
//   //     // if (data) {
//   //     //   socketService.off("count-unread-chats");
//   //     // }
//   //     dispatch(setChatCount(data.unreadUsersCount))
//   //   }
//   //   try {
//   //     // if (!socketService.connected) {
//   //     //   socketService.connect();
//   //     // }
//   //     socketService.on("connect", () => {
//   //       socketService.emit("join", { userId: authenticatedId });

//   //       socketService.on("joined-room", (data) => {
//   //         console.log("Joined confirmation:", data);
//   //       });
//   //       // Emit the unread notifications request
//   //       const emitNotificationUnread = () => {
//   //         socketService.emit("notifications-unread", {
//   //           userId: authenticatedId,
//   //           userType: loggedInUserType
//   //         });
//   //         socketService.emit("count-unread-users", {
//   //           userId: authenticatedId,
//   //           userType: loggedInUserType
//   //         });
//   //       };
//   //       // Listen to real-time notification updates
//   //       socketService.on("increaseUnreadCount", handleIncreaseCount);
//   //       socketService.on("count-unread-chats", handleChatCount)
//   //       socketService.on("notifications-unread", handleNotificationUnread);
//   //       socketService.on("user-action-notification", handleUserActionNotification);
//   //       // Emit immediately once
//   //       emitNotificationUnread();
//   //       // Set an interval to emit every 5 seconds
//   //       const intervalId = setInterval(emitNotificationUnread, 50000);
//   //       // Cleanup function to remove listeners
//   //       return () => {
//   //         clearInterval(intervalId);
//   //         socketService.off("notifications-unread");
//   //         socketService.off("increaseUnreadCount");
//   //         socketService.off("user-action-notification");
//   //         socketService.off("count-unread-chats");
//   //         socketService.disconnect();
//   //       };
//   //     });
//   //     socketService.on("connect_error", (err) => {
//   //       console.error("Connection Error:", err);
//   //     });
//   //   } catch (err) {
//   //     console.log(err, "errorData");
//   //   }
//   // }, [authenticatedId, loggedInUserType, dispatch]);

//   // useEffect(() => {
//   //   // Only proceed if we have authentication data
//   //   if (!authenticatedId || !loggedInUserType) return;

//   //   console.log("Setting up socket connection");

//   //   // Define all your handlers
//   //   const handleNotificationUnread = (data) => {
//   //     console.log("Received notification count:", data.count);
//   //     dispatch(setNotificationCount(data.count));
//   //   };

//   //   const handleUserActionNotification = (data) => {
//   //     console.log("Received action notification:", data);
//   //     dispatch(setNotificationCount((prevCount) => prevCount + 1));
//   //   };

//   //   const handleIncreaseCount = (data) => {
//   //     console.log("Received chat count increase");
//   //     dispatch(setChatCount((prevCount) => prevCount + 1));
//   //   };

//   //   const handleChatCount = (data) => {
//   //     console.log("Received chat count:", data.unreadUsersCount);
//   //     dispatch(setChatCount(data.unreadUsersCount));
//   //   };

//   //   // IMPORTANT: Handle the connection event FIRST before setting up other listeners
//   //   socketService.on("connect", () => {
//   //     console.log("Socket connected successfully");

//   //     // Join user's room
//   //     socketService.emit("join", { userId: authenticatedId });

//   //     // Initial data request AFTER confirmed connection
//   //     const requestInitialData = () => {
//   //       console.log("Requesting initial notification and chat data");
//   //       socketService.emit("notifications-unread", {
//   //         userId: authenticatedId,
//   //         userType: loggedInUserType
//   //       });

//   //       socketService.emit("count-unread-users", {
//   //         userId: authenticatedId,
//   //         userType: loggedInUserType
//   //       });
//   //     };

//   //     // Wait a moment for connection to stabilize before requesting data
//   //     setTimeout(requestInitialData, 500);

//   //     // Set periodic updates with longer interval (50s is fine)
//   //     const intervalId = setInterval(requestInitialData, 50000);

//   //     // Store intervalId for cleanup
//   //     return () => clearInterval(intervalId);
//   //   });

//   //   // Set up all event listeners OUTSIDE the connect handler
//   //   socketService.on("joined-room", (data) => {
//   //     console.log("Joined room confirmation:", data);
//   //   });

//   //   socketService.on("increaseUnreadCount", handleIncreaseCount);
//   //   socketService.on("count-unread-chats", handleChatCount);
//   //   socketService.on("notifications-unread", handleNotificationUnread);
//   //   socketService.on("user-action-notification", handleUserActionNotification);

//   //   // Handle connection errors
//   //   socketService.on("connect_error", (err) => {
//   //     console.error("Socket connection error:", err);
//   //   });

//   //   // Connect if not already connected
//   //   if (!socketService.connected) {
//   //     console.log("Initiating socket connection");
//   //     socketService.connect();
//   //   }

//   //   // Cleanup function
//   //   return () => {
//   //     console.log("Cleaning up socket connections");
//   //     socketService.off("joined-room");
//   //     socketService.off("increaseUnreadCount");
//   //     socketService.off("count-unread-chats");
//   //     socketService.off("notifications-unread");
//   //     socketService.off("user-action-notification");
//   //     socketService.off("connect_error");
//   //     socketService.off("connect");

//   //     // Don't disconnect here if you want to maintain connection between page navigations
//   //     // socketService.disconnect();
//   //   };
//   // }, [authenticatedId, loggedInUserType, dispatch]);

//   // const accessToken = localStorage.getItem('token') || localStorage.getItem('authToken') || localStorage.getItem('AuthenticationResult') || '';
//   // console.log("Access Token:", accessToken["data"]);

//   const fetchUnreadChatCount = async (userId, userType) => {
//     try {
//       const tokenData = localStorage.getItem('AuthenticationResult');
//       let accessToken = null;

//       if (tokenData) {
//         const parsedTokenData = JSON.parse(tokenData);
//         accessToken = parsedTokenData.data.AccessToken;
//       }
//       console.log("Access Token:", accessToken);

//       if (!accessToken) {
//         console.error('Access token not found in localStorage');
//         return;
//       }
//       // const res = await fetch(`${process.env.REACT_APP_API_CHAT_ENDPOINT}count-unread-users?userId=${userId}&userType=${userType}`);
//       const res = await fetch(
//         `${process.env.REACT_APP_API_CHAT_ENDPOINT}count-unread-users?userId=${userId}&userType=${userType}`,
//         {
//           method: 'GET',
//           headers: {
//             'includeAuthorizationHeaders': 'true',
//             'Authorization': accessToken,
//             'Content-Type': 'application/json'
//           }
//         }
//       );
//       const data = await res.json();
//       dispatch(setChatCount(data.unreadUsersCount));
//     } catch (err) {
//       console.error("Error fetching unread chat count:", err);
//     }
//   };

//   const fetchNotificationCount = async (userId, userType) => {
//     try {
//       const tokenData = localStorage.getItem('AuthenticationResult');
//       let accessToken = null;

//       if (tokenData) {
//         const parsedTokenData = JSON.parse(tokenData);
//         accessToken = parsedTokenData.data.AccessToken;
//       }
//       console.log("Access Token:", accessToken);

//       if (!accessToken) {
//         console.error('Access token not found in localStorage');
//         return;
//       }
//       // const res = await fetch(`${process.env.REACT_APP_API_CHAT_ENDPOINT}count-unread-users?userId=${userId}&userType=${userType}`);
//       const res = await fetch(
//         `${process.env.REACT_APP_API_CHAT_ENDPOINT}notifications-unread?userId=${userId}&userType=${userType}`,
//         {
//           method: 'GET',
//           headers: {
//             'includeAuthorizationHeaders': 'true',
//             'Authorization': accessToken,
//             'Content-Type': 'application/json'
//           }
//         }
//       );
//       // const res = await fetch(`${process.env.REACT_APP_API_CHAT_ENDPOINT}notifications-unread?userId=${userId}&userType=${userType}`);
//       const data = await res.json();
//       console.log("Notification count data:", data);
//       dispatch(setNotificationCount(data.count));
//     } catch (err) {
//       console.error("Error fetching unread chat count:", err);
//     }
//   };

//   // useEffect(() => {
//   //   if (!authenticatedId || !loggedInUserType) return;

//   //   console.log("Fetching initial unread chat count");

//   //   // 1. CALL THE API IMMEDIATELY (independent of socket)
//   //   fetchUnreadChatCount(authenticatedId, loggedInUserType);
//   //   fetchNotificationCount(authenticatedId, loggedInUserType);

//   //   // 2. Set up socket connection and listeners for real-time updates
//   //   const handleIncreaseCount = (data) => {
//   //     console.log("Real-time: Received chat count increase");
//   //     dispatch(setChatCount((prev) => prev + 1));
//   //   };

//   //   const handleChatCount = (data) => {
//   //     console.log("Real-time: Received unread chat count:", data.unreadUsersCount);
//   //     dispatch(setChatCount(data.unreadUsersCount));
//   //   };

//   //   const handleUserActionNotification = (data) => {
//   //     console.log("Received action notification:", data);
//   //     dispatch(setNotificationCount((prevCount) => prevCount + 1));
//   //   };

//   //      // Define all your handlers
//   //   const handleNotificationUnread = (data) => {
//   //     console.log("Received notification count:", data.count);
//   //     dispatch(setNotificationCount(data.count));
//   //   };
//   //   socketService.on("connect", () => {
//   //     console.log("Socket connected");
//   //     socketService.emit("join", { userId: authenticatedId });

//   //     // Emit for real-time sync (optional)
//   //     socketService.emit("count-unread-users", {
//   //       userId: authenticatedId,
//   //       userType: loggedInUserType
//   //     });
//   //   });

//   //   socketService.on("increaseUnreadCount", handleIncreaseCount);
//   //   // socketService.on("count-unread-chats", handleChatCount);
//   //   socketService.on("count-unread-chats", (data) => {
//   //     console.log("Real-time update received:", data);
//   //     dispatch(setChatCount(data.unreadUsersCount));
//   //   });
//   //   socketService.on("notifications-unread", handleNotificationUnread);
//   //   socketService.on("user-action-notification", handleUserActionNotification);
//   //   socketService.on("connect_error", (err) => {
//   //     console.error("Socket connection error:", err);
//   //   });

//   //   if (!socketService.connected) {
//   //     console.log("Connecting socket...");
//   //     socketService.connect();
//   //   }

//   //   return () => {
//   //     console.log("Cleaning up socket listeners");
//   //     socketService.off("increaseUnreadCount");
//   //     socketService.off("count-unread-chats");
//   //     socketService.off("notifications-unread");
//   //     socketService.off("user-action-notification");
//   //     socketService.off("connect");
//   //     socketService.off("connect_error");
//   //   };
//   // }, [authenticatedId, loggedInUserType, dispatch]);  

//   useEffect(() => {
//     if (!authenticatedId || !loggedInUserType) return;

//     console.log("Setting up socket and fetching initial counts");

//     // 1. CALL THE API IMMEDIATELY (independent of socket)
//     fetchUnreadChatCount(authenticatedId, loggedInUserType);
//     fetchNotificationCount(authenticatedId, loggedInUserType);

//     // 2. Define all event handlers
//     const handleIncreaseCount = (data) => {
//       console.log("Real-time: Received chat count increase");
//       dispatch(setChatCount((prev) => prev + 1));
//     };

//     const handleChatCount = (data) => {
//       console.log("Real-time update received:", data);
//       if (data && typeof data.unreadUsersCount !== 'undefined') {
//         console.log("Setting chat count to:", data.unreadUsersCount);
//         dispatch(setChatCount(data.unreadUsersCount));
//       } else {
//         console.warn("Received invalid data format for count-unread-chats:", data);
//       }
//     };

//     const handleUserActionNotification = (data) => {
//       console.log("Received action notification:", data);
//       dispatch(setNotificationCount(20));
//     };

//     const handleNotificationUnread = (data) => {
//       console.log("Received notification count:", data.count);
//       dispatch(setNotificationCount(data.count));
//       if (data.count === 0) {
//         console.log("Setting notification count to 1");
//         dispatch(setNotificationCount(1));
//       }
//     };

//     // 3. Setup function to establish socket connection and join room
//     const setupSocketConnection = () => {
//       // Always ensure we're connected before setting up listeners
//       if (!socketService.connected) {
//         console.log("Connecting socket...");
//         socketService.connect();
//       }

//       // Join user's personal room
//       console.log(`Joining room for user ${authenticatedId}`);
//       socketService.emit("join", { userId: authenticatedId });

//       // Request initial counts via socket
//       socketService.emit("count-unread-users", {
//         userId: authenticatedId,
//         userType: loggedInUserType
//       });
//     };

//     // 4. Connection event handler
//     const handleConnect = () => {
//       console.log("Socket connected");

//       // Join room and request initial counts
//       socketService.emit("join", { userId: authenticatedId });

//       // Emit for real-time sync
//       socketService.emit("count-unread-users", {
//         userId: authenticatedId,
//         userType: loggedInUserType
//       });
//     };

//     const handleGlobalCheck = () => {
//       console.log("Global check event triggered");
//       const userIds = [authenticatedId];
//       socketService.emit("notifications-unread", {
//         userIds,
//         userType: loggedInUserType
//       });
//     }

//     // 5. Register event handlers
//     socketService.on("global-check", handleGlobalCheck);
//     socketService.on("connect", handleConnect);
//     socketService.on("increaseUnreadCount", handleIncreaseCount);
//     socketService.on("count-unread-chats", handleChatCount);
//     socketService.on("notifications-unread", handleNotificationUnread);
//     socketService.on("user-action-notification", handleUserActionNotification);
//     socketService.on("connect_error", (err) => {
//       console.error("Socket connection error:", err);
//     });

//     // 6. Initial connection setup
//     setupSocketConnection();

//     // 7. Add connection monitoring to ensure stability
//     const connectionMonitor = setInterval(() => {
//       if (!socketService.connected) {
//         console.log("Socket connection lost, reconnecting...");
//         setupSocketConnection();
//       }
//     }, 5000); // Check every 10 seconds

//     // 8. Cleanup function
//     return () => {
//       console.log("Cleaning up socket listeners");
//       clearInterval(connectionMonitor);
//       socketService.off("global-check", handleGlobalCheck);
//       socketService.off("increaseUnreadCount", handleIncreaseCount);
//       socketService.off("count-unread-chats", handleChatCount);
//       socketService.off("notifications-unread", handleNotificationUnread);
//       socketService.off("user-action-notification", handleUserActionNotification);
//       socketService.off("connect", handleConnect);
//       socketService.off("connect_error");
//     };
//   }, [authenticatedId, loggedInUserType, dispatch]);

//   // useEffect(() => {
//   //   if (!authenticatedId || !loggedInUserType) return;

//   //   const handleNotificationUnread = (data) => {
//   //     dispatch(setNotificationCount(data.count));
//   //   };

//   //   const handleUserActionNotification = (data) => {
//   //     console.log("Received action notification:", data);
//   //     dispatch(setNotificationCount((prevCount) => prevCount + 1)); // Increment unread count dynamically
//   //   };

//   //   const handleChatCount = (data) => {
//   //     console.log("chat count ...", data.unreadUsersCount);
//   //     dispatch(setChatCount(data.unreadUsersCount));
//   //   };

//   //   try {
//   //     socketService.on("connect", () => {
//   //       socketService.emit("join", { userId: authenticatedId });

//   //       socketService.on("joined-room", (data) => {
//   //         console.log("Joined confirmation:", data);
//   //       });

//   //       // Emit the unread notifications request once
//   //       socketService.emit("notifications-unread", {
//   //         userId: authenticatedId,
//   //         userType: loggedInUserType
//   //       });

//   //       socketService.emit("count-unread-users", {
//   //         userId: authenticatedId,
//   //         userType: loggedInUserType
//   //       });

//   //       // Listen to real-time notification updates
//   //       socketService.on("count-unread-chats", handleChatCount);
//   //       socketService.on("notifications-unread", handleNotificationUnread);
//   //       socketService.on("user-action-notification", handleUserActionNotification);
//   //     });

//   //     socketService.on("connect_error", (err) => {
//   //       console.error("Connection Error:", err);
//   //     });

//   //     // Cleanup function to remove listeners and disconnect socket
//   //     return () => {
//   //       socketService.off("count-unread-chats", handleChatCount);
//   //       socketService.off("notifications-unread", handleNotificationUnread);
//   //       socketService.off("user-action-notification", handleUserActionNotification);
//   //       socketService.disconnect();
//   //     };
//   //   } catch (err) {
//   //     console.log(err, "errorData");
//   //   }
//   // }, [authenticatedId, loggedInUserType, dispatch]);

//   if (!hasAccess) {
//     return (
//       <div className="password-protected-page" style={styles.container}>
//         <form onSubmit={handlePasswordSubmit} style={{ textAlign: 'center' }}>
//           <h1 style={styles.heading}>🔒 Password Required</h1>
//           <InputField
//             label=""
//             id="password"
//             variant={componentSizeVariantsEnum.LARGE}
//             placeholder="Password"
//             startIcon={<PasswordIcon />}
//             endIcon={maskPassword ? <EyeOffIcon /> : <EyeIcon />}
//             maskField={maskPassword}
//             endIconClickHandler={() => setMaskPassword((prev) => !prev)}
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}

//           />
//           {/* <input
//             type="password"
//             placeholder="Enter password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             style={styles.input}
//           /> */}
//           {/* <button type="submit" style={styles.button}>
//             Submit
//           </button> */}
//           <Button variant="primary" size="small" type="submit" style={{ marginTop: '14px' }}>
//             <Typography as="span" variant="body-2" fontWeight="semiBold">
//               Submit
//             </Typography>
//           </Button>
//         </form>
//       </div>
//     );
//   }

//   if (isAuthorizationCheckInProgress) {
//     return <PageLoader />;
//   }

//   return (
//     <Fragment>
//       {openInviteUserModal && isAuthorized && (
//         <InviteUser isModalOpen={openInviteUserModal} closeModal={handleCloseInviteUserModal} />
//       )}
//       {isSignOutModalOpen && (
//         <ConfirmModal
//           title="Are you sure you want to logout from your account?"
//           openConfirmModal={isSignOutModalOpen}
//           onClose={closeSignOutModal}
//           onSubmit={handleSignOut}
//           submitText="Logout"
//           type="error"
//         />
//       )}
//       <Helmet>
//         <title>htraction | Platform for Entrepreneurs | Startup showcase & funding</title>
//         <meta
//           name="description"
//           content="A startup success platform: Validate your idea using AI, Showcase your idea & startup for feedback & funding, discover all the programs by incubators"
//         />

//         {/* Open Graph Tags */}
//         <meta property="og:title" content="htraction | Platform for Entrepreneurs" />
//         <meta
//           property="og:description"
//           content="A startup success platform: Validate your idea using AI, Showcase your idea & startup for feedback & funding, discover all the programs by incubators"
//         />
//         <meta
//           name="keywords"
//           content="startup platform, incubator programs, investors, funding, idea validation, pitch deck, entrepreneurship, startup showcase, accelerator, early-stage startups, htraction"
//         />
//         <meta property="og:image" content="https://castling.in/ogimage.png?v=2" />
//         <meta property="og:url" content="https://castling.in/" />
//         <meta property="og:type" content="website" />
//         <meta property="og:site_name" content="htraction" />

//         {/* Twitter Tags */}
//         <meta name="twitter:card" content="summary_large_image" />
//         <meta name="twitter:title" content="htraction | Platform for Entrepreneurs" />
//         <meta
//           name="twitter:description"
//           content="A startup success platform: Validate your idea using AI, Showcase your idea & startup for feedback & funding, discover all the programs by incubators"
//         />
//         <meta name="twitter:image" content="https://castling.in/ogimage.png?v=2" />
//       </Helmet>

//       <ErrorBoundary>
//         <Routes isAuthorized={isAuthorized} />
//       </ErrorBoundary>
//       <Popup />
//     </Fragment>
//   );
// };

// const styles = {
//   container: {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     height: '100vh',
//     backgroundColor: '#f4f4f9'
//   },
//   form: {
//     background: '#fff',
//     padding: '2rem',
//     borderRadius: '8px',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//     textAlign: 'center',
//     width: '300px'
//   },
//   heading: {
//     fontSize: '1.5rem',
//     marginBottom: '1.5rem',
//     color: '#333'
//   },
//   input: {
//     width: '100%',
//     padding: '0.8rem',
//     fontSize: '1rem',
//     borderRadius: '4px',
//     border: '1px solid #ddd',
//     marginBottom: '1rem',
//     outline: 'none'
//   },
//   button: {
//     backgroundColor: '#007bff',
//     color: '#fff',
//     padding: '0.8rem 1.5rem',
//     fontSize: '1rem',
//     border: 'none',
//     borderRadius: '4px',
//     cursor: 'pointer',
//     transition: 'background-color 0.3s ease'
//   }
// };

// export default App;

import { Fragment, useEffect, useState, type ReactNode, useRef } from 'react';
import { isSupported } from 'firebase/messaging';

import './App.css';
import { Routes } from './routes/routes';
import Popup from './components/common/popup/Popup';
import { useAppDispatch, useAppSelector } from './store/hooks';
import { getProfile } from './store/profile/profile.slice';
import { StorageUtils } from './utils';
import PageLoader from './components/common/pageLoader/PageLoader';
import { useForceCreateCompany, useGetIdentity, useListenToChatNotifications, useSignOut } from './hooks';
import { getCompany } from './store/company/company.slice';
import { userAuthorizationFailure } from './store/auth/auth.slice';
import ErrorBoundary from './components/common/errorBoundary/ErrorBoundary';
import useGetNotifications from './firebase/useGetNotifications';
import { Helmet } from "react-helmet";
import { InputField } from './components/common/formFields';
import { componentSizeVariantsEnum } from './constants';
import { EyeIcon, EyeOffIcon, PasswordIcon } from './components/common/common.icons';
import { Button, ConfirmModal, Typography } from './components/common';
import { assignModalId, resetConfirmModalId } from './store/common/common.slice';
import InviteUser from './components/header/inviteUser/InviteUser';
import { inviteUserModalId } from './components/cards/inviteNetwork';
import { socketService } from './services/socket.api.service';
// import { io } from 'socket.io-client';
import { setChatCount, setNotificationCount } from './store/chat/chat.slice';
import { useNavigate } from 'react-router-dom';
import { start } from 'node:repl';
const signOutModalId = 'sign-up-modal-id';
const App = (): ReactNode => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useForceCreateCompany();
  useGetNotifications();
  useListenToChatNotifications();

  const { isAuthorized, isAuthorizationCheckInProgress } = useAppSelector((store) => store.auth);
  const { confirmModalId, modalId } = useAppSelector((store) => store.common);
  const { chatCount } = useAppSelector((store) => store.chat);
  const { getIdentities } = useGetIdentity();
  const { loggedInUserType, authenticatedId } = getIdentities();
  const signOut = useSignOut();
  const isSignOutModalOpen = confirmModalId === signOutModalId;
  const openInviteUserModal = modalId === inviteUserModalId;

  // const socketUrl = process.env.REACT_APP_API_CHAT_SOCKET_ENDPOINT || '';
  // console.log(socketUrl, 'socketUrl');
  // const socketService = io(socketUrl, { transports: ['websocket'] });

  useEffect(() => {
    const userId = StorageUtils.get('userId') as unknown as string;
    const companyId = StorageUtils.get('companyId') as unknown as string;
    if (companyId) {
      dispatch(getCompany({ id: companyId }));
    }
    if (userId) {
      dispatch(getProfile({ id: userId }));
    } else if (!companyId && !userId) {
      dispatch(userAuthorizationFailure());
    }
  }, []);

  const registerNotificationServiceWorker = () => {
    isSupported()
      .then((supported) => {
        if (supported) {
          if ('serviceWorker' in navigator) {
            navigator.serviceWorker
              .register('/firebase-messaging-sw.js')
              .then((registration) => {
                console.log('Service Worker registered with scope:', registration.scope);
              })
              .catch((error) => {
                console.error('Service Worker registration failed:', error);
              });
          }
        } else {
          console.log(
            'This browser does not support the APIs required for Firebase Cloud Messaging.'
          );
        }
      })
      .catch((error) => {
        console.error('Error checking API support: ', error);
      });
  };

  useEffect(() => {
    registerNotificationServiceWorker();
  }, []);

  const closeSignOutModal = () => {
    dispatch(resetConfirmModalId());
  };
  const handleSignOut = () => {
    signOut();
  };
  const handleCloseInviteUserModal = () => {
    dispatch(assignModalId(''));
  };
  // console.log(chatCount, 'chatCount');

  // only for real time update
  // useEffect(() => {
  //   socketService.on("user-action-notification", (data) => {
  //     console.log("Received action notification:", data);
  //     const handleNotificationUnread = () => {
  //       dispatch(setNotificationCount(10));
  //     };
  //     handleNotificationUnread();
  //     alert(`Action: ${data.actionType} - ${data.message}`);
  // });

  // return () => {
  //     socketService.off("user-action-notification");
  // };
  // }, []);

  // previous checking after every 5 second
  // useEffect(() => {
  //   if (authenticatedId && loggedInUserType) {
  //     const handleNotificationUnread = (data) => {
  //       dispatch(setNotificationCount(data.count));
  //     };
  //     try {
  //       socketService.connect();
  //       socketService.on("connect", () => {
  //         socketService.emit("join", { userId: authenticatedId });
  //         socketService.on("joined-room", (data) => {
  //           console.log("Joined confirmation:", data);
  //         });

  //         // Function to emit the event
  //         const emitNotificationUnread = () => {
  //           socketService.emit("notifications-unread", {
  //             userId: authenticatedId,
  //             userType: loggedInUserType
  //           });
  //           socketService.on("notifications-unread", handleNotificationUnread);
  //         };

  //         // Emit immediately once
  //         emitNotificationUnread();

  //         // Set an interval to emit every 5 seconds
  //         const intervalId = setInterval(emitNotificationUnread, 5000);

  //         const handleIdeaConversation = (data) => {
  //           console.log(`Received message in ${authenticatedId}:`, data);
  //         };

  //         socketService.on("idea-conversation", handleIdeaConversation);

  //         socketService.on("connect_error", (err) => {
  //           console.error("Connection Error:", err);
  //         });

  //         // Cleanup when component unmounts
  //         return () => {
  //           clearInterval(intervalId);
  //           socketService.off("notifications-unread", handleNotificationUnread);
  //           socketService.off("idea-conversation", handleIdeaConversation);
  //           socketService.off("connect_error");
  //           socketService.disconnect();
  //         };
  //       });
  //     } catch (err) {
  //       console.log(err, "errorData");
  //     }
  //   }
  // }, [authenticatedId, loggedInUserType]);

  const handlerRef = useRef(null);

  // useEffect(() => {
  //   if (!authenticatedId || !loggedInUserType) return;
  //   console.log("start socket")
  //   const handleChatCount = (data) => {
  //     console.log("chat count ...", data.unreadUsersCount);
  //     dispatch(setChatCount(data.unreadUsersCount));
  //   };

  //   handlerRef.current = handleChatCount;

  //   socketService.on("count-unread-chats", handlerRef.current);

  //   const cleanup = () => {
  //     setTimeout(() => {
  //       socketService.off("count-unread-chats", handlerRef.current);
  //     }, 100); // Small delay to allow the event to finish processing
  //   };

  //   return cleanup;
  // }, [authenticatedId, loggedInUserType, dispatch]);

  // useEffect(() => {
  //   console.log("----------------------------------------------------------------------check-------------------------------")
  //   socketService.on("count-unread-chats", (data) => {
  //     console.log("chat count ...", data.unreadUsersCount);
  //     dispatch(setChatCount(data.unreadUsersCount));
  //   });
  // }, [])

  // const startSocket = async () => {
  //   useEffect(() => {
  //     console.log("start socket 101----------------------102----------------103")
  //     if (!authenticatedId || !loggedInUserType) return;
  //     console.log(socketService, 'socketService');

  //     const handleNotificationUnread = (data) => {
  //       dispatch(setNotificationCount(data.count));
  //     };

  //     const handleUserActionNotification = (data) => {
  //       console.log("Received action notification:", data);
  //       dispatch(setNotificationCount((prevCount) => prevCount + 1)); // Increment unread count dynamically
  //       // alert(`Action: ${data.actionType} - ${data.message}`);
  //     };

  //     const handleChatCount = (data) => {
  //       console.log("chat count ...  //     const handleIncreaseCount = (data) => {
  //       console.log("Received action notification:", data);
  //       dispatch(setChatCount((prevCount) => prevCount + 1)); // Increment unread count dynamically
  //       // alert(`Action: ${data.actionType} - ${data.message}`);
  //     };", data.unreadUsersCount)
  //       if (data) {
  //         socketService.off("count-unread-chats", handleChatCount);
  //       }
  //       dispatch(setChatCount(data.unreadUsersCount))
  //     }
  //     try {
  //       // if (!socketService.connected) {
  //       //   socketService.connect();
  //       // }
  //       socketService.on("connect", () => {
  //         socketService.emit("join", { userId: authenticatedId });

  //         socketService.on("joined-room", (data) => {
  //           console.log("Joined confirmation:", data);
  //         });
  //         // Emit the unread notifications request
  //         const emitNotificationUnread = () => {
  //           socketService.emit("notifications-unread", {
  //             userId: authenticatedId,
  //             userType: loggedInUserType
  //           });
  //           socketService.emit("count-unread-users", {
  //             userId: authenticatedId,
  //             userType: loggedInUserType
  //           });
  //         };
  //         // Listen to real-time notification updates
  //         socketService.on("increaseUnreadCount", handleIncreaseCount);
  //         socketService.on("count-unread-chats", handleChatCount)
  //         socketService.on("notifications-unread", handleNotificationUnread);
  //         socketService.on("user-action-notification", handleUserActionNotification);
  //         // Emit immediately once
  //         emitNotificationUnread();
  //         // Set an interval to emit every 5 seconds
  //         const intervalId = setInterval(emitNotificationUnread, 5000);
  //         // Cleanup function to remove listeners
  //         return () => {
  //           clearInterval(intervalId);
  //           socketService.off("notifications-unread");
  //           socketService.off("increaseUnreadCount");
  //           socketService.off("user-action-notification");
  //           socketService.off("count-unread-chats", handleChatCount);
  //           // socketService.disconnect();
  //         };
  //       });
  //       socketService.on("connect_error", (err) => {
  //         console.error("Connection Error:", err);
  //       });
  //     } catch (err) {
  //       console.log(err, "errorData");
  //     }
  //   }, [authenticatedId, loggedInUserType, dispatch]);
  // };
  // startSocket();
  // combined both every 5 sec and real time update

  //   useEffect(() => {
  //     console.log("start socket 101----------------------102----------------103");

  //     if (!authenticatedId || !loggedInUserType) return;
  //     console.log(socketService, "socketService");

  //     const handleNotificationUnread = (data) => {
  //         dispatch(setNotificationCount(data.count));
  //     };

  //     const handleUserActionNotification = (data) => {
  //         console.log("Received action notification:", data);
  //         dispatch(setNotificationCount((prevCount) => prevCount + 1));
  //     };

  //     const handleIncreaseCount = (data) => {
  //         console.log("Received action notification:", data);
  //         dispatch(setChatCount((prevCount) => prevCount + 1));
  //     };

  //     const handleChatCount = (data) => {
  //         console.log("chat count ...", data.unreadUsersCount);
  //         dispatch(setChatCount(data.unreadUsersCount));
  //     };

  //     // Emit the unread notifications request
  //     const emitNotificationUnread = () => {
  //         socketService.emit("notifications-unread", {
  //             userId: authenticatedId,
  //             userType: loggedInUserType
  //         });
  //         socketService.emit("count-unread-users", {
  //             userId: authenticatedId,
  //             userType: loggedInUserType
  //         });
  //     };

  //     // Listen to real-time notification updates
  //     socketService.on("increaseUnreadCount", handleIncreaseCount);
  //     socketService.on("count-unread-chats", handleChatCount);
  //     socketService.on("notifications-unread", handleNotificationUnread);
  //     socketService.on("user-action-notification", handleUserActionNotification);

  //     // Emit immediately once
  //     emitNotificationUnread();
  //     // Set an interval to emit every 50 seconds
  //     const intervalId = setInterval(emitNotificationUnread, 50000);

  //     // Cleanup function (only clearing interval)
  //     return () => {
  //         clearInterval(intervalId);
  //     };
  // }, [authenticatedId, loggedInUserType, dispatch]);

  // useEffect(() => {
  //   console.log("start socket 101----------------------102----------------103")
  //   // dispatch(setChatCount(4))
  //   // dispatch(setNotificationCount(5))
  //   if (!authenticatedId || !loggedInUserType) return;
  //   console.log(socketService, 'socketService');

  //   const handleNotificationUnread = (data) => {
  //     dispatch(setNotificationCount(data.count));
  //   };

  //   const handleUserActionNotification = (data) => {
  //     console.log("Received action notification:", data);
  //     dispatch(setNotificationCount((prevCount) => prevCount + 1)); // Increment unread count dynamically
  //     // alert(`Action: ${data.actionType} - ${data.message}`);
  //   };
  //   const handleIncreaseCount = (data) => {
  //     console.log("Received action notification:", data);
  //     dispatch(setChatCount((prevCount) => prevCount + 1)); // Increment unread count dynamically
  //     // alert(`Action: ${data.actionType} - ${data.message}`);
  //   };
  //   const handleChatCount = (data) => {
  //     console.log("chat count ...", data.unreadUsersCount)
  //     // if (data) {
  //     //   socketService.off("count-unread-chats");
  //     // }
  //     dispatch(setChatCount(data.unreadUsersCount))
  //   }
  //   try {
  //     // if (!socketService.connected) {
  //     //   socketService.connect();
  //     // }
  //     socketService.on("connect", () => {
  //       socketService.emit("join", { userId: authenticatedId });

  //       socketService.on("joined-room", (data) => {
  //         console.log("Joined confirmation:", data);
  //       });
  //       // Emit the unread notifications request
  //       const emitNotificationUnread = () => {
  //         socketService.emit("notifications-unread", {
  //           userId: authenticatedId,
  //           userType: loggedInUserType
  //         });
  //         socketService.emit("count-unread-users", {
  //           userId: authenticatedId,
  //           userType: loggedInUserType
  //         });
  //       };
  //       // Listen to real-time notification updates
  //       socketService.on("increaseUnreadCount", handleIncreaseCount);
  //       socketService.on("count-unread-chats", handleChatCount)
  //       socketService.on("notifications-unread", handleNotificationUnread);
  //       socketService.on("user-action-notification", handleUserActionNotification);
  //       // Emit immediately once
  //       emitNotificationUnread();
  //       // Set an interval to emit every 5 seconds
  //       const intervalId = setInterval(emitNotificationUnread, 50000);
  //       // Cleanup function to remove listeners
  //       return () => {
  //         clearInterval(intervalId);
  //         socketService.off("notifications-unread");
  //         socketService.off("increaseUnreadCount");
  //         socketService.off("user-action-notification");
  //         socketService.off("count-unread-chats");
  //         socketService.disconnect();
  //       };
  //     });
  //     socketService.on("connect_error", (err) => {
  //       console.error("Connection Error:", err);
  //     });
  //   } catch (err) {
  //     console.log(err, "errorData");
  //   }
  // }, [authenticatedId, loggedInUserType, dispatch]);

  // useEffect(() => {
  //   // Only proceed if we have authentication data
  //   if (!authenticatedId || !loggedInUserType) return;

  //   console.log("Setting up socket connection");

  //   // Define all your handlers
  //   const handleNotificationUnread = (data) => {
  //     console.log("Received notification count:", data.count);
  //     dispatch(setNotificationCount(data.count));
  //   };

  //   const handleUserActionNotification = (data) => {
  //     console.log("Received action notification:", data);
  //     dispatch(setNotificationCount((prevCount) => prevCount + 1));
  //   };

  //   const handleIncreaseCount = (data) => {
  //     console.log("Received chat count increase");
  //     dispatch(setChatCount((prevCount) => prevCount + 1));
  //   };

  //   const handleChatCount = (data) => {
  //     console.log("Received chat count:", data.unreadUsersCount);
  //     dispatch(setChatCount(data.unreadUsersCount));
  //   };

  //   // IMPORTANT: Handle the connection event FIRST before setting up other listeners
  //   socketService.on("connect", () => {
  //     console.log("Socket connected successfully");

  //     // Join user's room
  //     socketService.emit("join", { userId: authenticatedId });

  //     // Initial data request AFTER confirmed connection
  //     const requestInitialData = () => {
  //       console.log("Requesting initial notification and chat data");
  //       socketService.emit("notifications-unread", {
  //         userId: authenticatedId,
  //         userType: loggedInUserType
  //       });

  //       socketService.emit("count-unread-users", {
  //         userId: authenticatedId,
  //         userType: loggedInUserType
  //       });
  //     };

  //     // Wait a moment for connection to stabilize before requesting data
  //     setTimeout(requestInitialData, 500);

  //     // Set periodic updates with longer interval (50s is fine)
  //     const intervalId = setInterval(requestInitialData, 50000);

  //     // Store intervalId for cleanup
  //     return () => clearInterval(intervalId);
  //   });

  //   // Set up all event listeners OUTSIDE the connect handler
  //   socketService.on("joined-room", (data) => {
  //     console.log("Joined room confirmation:", data);
  //   });

  //   socketService.on("increaseUnreadCount", handleIncreaseCount);
  //   socketService.on("count-unread-chats", handleChatCount);
  //   socketService.on("notifications-unread", handleNotificationUnread);
  //   socketService.on("user-action-notification", handleUserActionNotification);

  //   // Handle connection errors
  //   socketService.on("connect_error", (err) => {
  //     console.error("Socket connection error:", err);
  //   });

  //   // Connect if not already connected
  //   if (!socketService.connected) {
  //     console.log("Initiating socket connection");
  //     socketService.connect();
  //   }

  //   // Cleanup function
  //   return () => {
  //     console.log("Cleaning up socket connections");
  //     socketService.off("joined-room");
  //     socketService.off("increaseUnreadCount");
  //     socketService.off("count-unread-chats");
  //     socketService.off("notifications-unread");
  //     socketService.off("user-action-notification");
  //     socketService.off("connect_error");
  //     socketService.off("connect");

  //     // Don't disconnect here if you want to maintain connection between page navigations
  //     // socketService.disconnect();
  //   };
  // }, [authenticatedId, loggedInUserType, dispatch]);

  // const accessToken = localStorage.getItem('token') || localStorage.getItem('authToken') || localStorage.getItem('AuthenticationResult') || '';
  // console.log("Access Token:", accessToken["data"]);

  const fetchUnreadChatCount = async (userId, userType) => {
    try {
      const tokenData = localStorage.getItem('AuthenticationResult');
      let accessToken = null;

      if (tokenData) {
        const parsedTokenData = JSON.parse(tokenData);
        accessToken = parsedTokenData.data.AccessToken;
      }
      console.log("Access Token:", accessToken);

      if (!accessToken) {
        console.error('Access token not found in localStorage');
        return;
      }
      // const res = await fetch(`${process.env.REACT_APP_API_CHAT_ENDPOINT}count-unread-users?userId=${userId}&userType=${userType}`);
      const res = await fetch(
        `${process.env.REACT_APP_API_CHAT_ENDPOINT}count-unread-users?userId=${userId}&userType=${userType}`,
        {
          method: 'GET',
          headers: {
            'includeAuthorizationHeaders': 'true',
            'Authorization': accessToken,
            'Content-Type': 'application/json'
          }
        }
      );
      const data = await res.json();
      dispatch(setChatCount(data.unreadUsersCount));
    } catch (err) {
      console.error("Error fetching unread chat count:", err);
    }
  };

  const fetchNotificationCount = async (userId, userType) => {
    try {
      const tokenData = localStorage.getItem('AuthenticationResult');
      let accessToken = null;

      if (tokenData) {
        const parsedTokenData = JSON.parse(tokenData);
        accessToken = parsedTokenData.data.AccessToken;
      }
      console.log("Access Token:", accessToken);

      if (!accessToken) {
        console.error('Access token not found in localStorage');
        return;
      }
      // const res = await fetch(`${process.env.REACT_APP_API_CHAT_ENDPOINT}count-unread-users?userId=${userId}&userType=${userType}`);
      const res = await fetch(
        `${process.env.REACT_APP_API_CHAT_ENDPOINT}notifications-unread?userId=${userId}&userType=${userType}`,
        {
          method: 'GET',
          headers: {
            'includeAuthorizationHeaders': 'true',
            'Authorization': accessToken,
            'Content-Type': 'application/json'
          }
        }
      );
      // const res = await fetch(`${process.env.REACT_APP_API_CHAT_ENDPOINT}notifications-unread?userId=${userId}&userType=${userType}`);
      const data = await res.json();
      console.log("Notification count data:", data);
      dispatch(setNotificationCount(data.count));
    } catch (err) {
      console.error("Error fetching unread chat count:", err);
    }
  };

  // useEffect(() => {
  //   if (!authenticatedId || !loggedInUserType) return;

  //   console.log("Fetching initial unread chat count");

  //   // 1. CALL THE API IMMEDIATELY (independent of socket)
  //   fetchUnreadChatCount(authenticatedId, loggedInUserType);
  //   fetchNotificationCount(authenticatedId, loggedInUserType);

  //   // 2. Set up socket connection and listeners for real-time updates
  //   const handleIncreaseCount = (data) => {
  //     console.log("Real-time: Received chat count increase");
  //     dispatch(setChatCount((prev) => prev + 1));
  //   };

  //   const handleChatCount = (data) => {
  //     console.log("Real-time: Received unread chat count:", data.unreadUsersCount);
  //     dispatch(setChatCount(data.unreadUsersCount));
  //   };

  //   const handleUserActionNotification = (data) => {
  //     console.log("Received action notification:", data);
  //     dispatch(setNotificationCount((prevCount) => prevCount + 1));
  //   };

  //      // Define all your handlers
  //   const handleNotificationUnread = (data) => {
  //     console.log("Received notification count:", data.count);
  //     dispatch(setNotificationCount(data.count));
  //   };
  //   socketService.on("connect", () => {
  //     console.log("Socket connected");
  //     socketService.emit("join", { userId: authenticatedId });

  //     // Emit for real-time sync (optional)
  //     socketService.emit("count-unread-users", {
  //       userId: authenticatedId,
  //       userType: loggedInUserType
  //     });
  //   });

  //   socketService.on("increaseUnreadCount", handleIncreaseCount);
  //   // socketService.on("count-unread-chats", handleChatCount);
  //   socketService.on("count-unread-chats", (data) => {
  //     console.log("Real-time update received:", data);
  //     dispatch(setChatCount(data.unreadUsersCount));
  //   });
  //   socketService.on("notifications-unread", handleNotificationUnread);
  //   socketService.on("user-action-notification", handleUserActionNotification);
  //   socketService.on("connect_error", (err) => {
  //     console.error("Socket connection error:", err);
  //   });

  //   if (!socketService.connected) {
  //     console.log("Connecting socket...");
  //     socketService.connect();
  //   }

  //   return () => {
  //     console.log("Cleaning up socket listeners");
  //     socketService.off("increaseUnreadCount");
  //     socketService.off("count-unread-chats");
  //     socketService.off("notifications-unread");
  //     socketService.off("user-action-notification");
  //     socketService.off("connect");
  //     socketService.off("connect_error");
  //   };
  // }, [authenticatedId, loggedInUserType, dispatch]);  

  useEffect(() => {
    if (!authenticatedId || !loggedInUserType) return;

    console.log("Setting up socket and fetching initial counts");

    // 1. CALL THE API IMMEDIATELY (independent of socket)
    fetchUnreadChatCount(authenticatedId, loggedInUserType);
    fetchNotificationCount(authenticatedId, loggedInUserType);

    // 2. Define all event handlers
    const handleIncreaseCount = (data) => {
      console.log("Real-time: Received chat count increase");
      dispatch(setChatCount((prev) => prev + 1));
    };

    const handleChatCount = (data) => {
      console.log("Real-time update received:", data);
      if (data && typeof data.unreadUsersCount !== 'undefined') {
        console.log("Setting chat count to:", data.unreadUsersCount);
        dispatch(setChatCount(data.unreadUsersCount));
      } else {
        console.warn("Received invalid data format for count-unread-chats:", data);
      }
    };

    const handleUserActionNotification = (data) => {
      console.log("Received action notification:", data);
      dispatch(setNotificationCount(20));
    };

    const handleNotificationUnread = (data) => {
      console.log("Received notification count:", data.count);
      dispatch(setNotificationCount(data.count));
      if (data.count === 0) {
        console.log("Setting notification count to 1");
        dispatch(setNotificationCount(1));
      }
    };

    // 3. Setup function to establish socket connection and join room
    const setupSocketConnection = () => {
      // Always ensure we're connected before setting up listeners
      if (!socketService.connected) {
        console.log("Connecting socket...");
        socketService.connect();
      }

      // Join user's personal room
      console.log(`Joining room for user ${authenticatedId}`);
      socketService.emit("join", { userId: authenticatedId });

      // Request initial counts via socket
      socketService.emit("count-unread-users", {
        userId: authenticatedId,
        userType: loggedInUserType
      });
    };

    // 4. Connection event handler
    const handleConnect = () => {
      console.log("Socket connected");

      // Join room and request initial counts
      socketService.emit("join", { userId: authenticatedId });

      // Emit for real-time sync
      socketService.emit("count-unread-users", {
        userId: authenticatedId,
        userType: loggedInUserType
      });
    };

    const handleGlobalCheck = () => {
      console.log("Global check event triggered");
      const userIds = [authenticatedId];
      socketService.emit("notifications-unread", {
        userIds,
        userType: loggedInUserType
      });
    }

    // 5. Register event handlers
    socketService.on("global-check", handleGlobalCheck);
    socketService.on("connect", handleConnect);
    socketService.on("increaseUnreadCount", handleIncreaseCount);
    socketService.on("count-unread-chats", handleChatCount);
    socketService.on("notifications-unread", handleNotificationUnread);
    socketService.on("user-action-notification", handleUserActionNotification);
    socketService.on("connect_error", (err) => {
      console.error("Socket connection error:", err);
    });

    // 6. Initial connection setup
    setupSocketConnection();

    // 7. Add connection monitoring to ensure stability
    const connectionMonitor = setInterval(() => {
      if (!socketService.connected) {
        console.log("Socket connection lost, reconnecting...");
        setupSocketConnection();
      }
    }, 5000); // Check every 10 seconds

    // 8. Cleanup function
    return () => {
      console.log("Cleaning up socket listeners");
      clearInterval(connectionMonitor);
      socketService.off("global-check", handleGlobalCheck);
      socketService.off("increaseUnreadCount", handleIncreaseCount);
      socketService.off("count-unread-chats", handleChatCount);
      socketService.off("notifications-unread", handleNotificationUnread);
      socketService.off("user-action-notification", handleUserActionNotification);
      socketService.off("connect", handleConnect);
      socketService.off("connect_error");
    };
  }, [authenticatedId, loggedInUserType, dispatch]);

  // useEffect(() => {
  //   if (!authenticatedId || !loggedInUserType) return;

  //   const handleNotificationUnread = (data) => {
  //     dispatch(setNotificationCount(data.count));
  //   };

  //   const handleUserActionNotification = (data) => {
  //     console.log("Received action notification:", data);
  //     dispatch(setNotificationCount((prevCount) => prevCount + 1)); // Increment unread count dynamically
  //   };

  //   const handleChatCount = (data) => {
  //     console.log("chat count ...", data.unreadUsersCount);
  //     dispatch(setChatCount(data.unreadUsersCount));
  //   };

  //   try {
  //     socketService.on("connect", () => {
  //       socketService.emit("join", { userId: authenticatedId });

  //       socketService.on("joined-room", (data) => {
  //         console.log("Joined confirmation:", data);
  //       });

  //       // Emit the unread notifications request once
  //       socketService.emit("notifications-unread", {
  //         userId: authenticatedId,
  //         userType: loggedInUserType
  //       });

  //       socketService.emit("count-unread-users", {
  //         userId: authenticatedId,
  //         userType: loggedInUserType
  //       });

  //       // Listen to real-time notification updates
  //       socketService.on("count-unread-chats", handleChatCount);
  //       socketService.on("notifications-unread", handleNotificationUnread);
  //       socketService.on("user-action-notification", handleUserActionNotification);
  //     });

  //     socketService.on("connect_error", (err) => {
  //       console.error("Connection Error:", err);
  //     });

  //     // Cleanup function to remove listeners and disconnect socket
  //     return () => {
  //       socketService.off("count-unread-chats", handleChatCount);
  //       socketService.off("notifications-unread", handleNotificationUnread);
  //       socketService.off("user-action-notification", handleUserActionNotification);
  //       socketService.disconnect();
  //     };
  //   } catch (err) {
  //     console.log(err, "errorData");
  //   }
  // }, [authenticatedId, loggedInUserType, dispatch]);

  if (isAuthorizationCheckInProgress) {
    return <PageLoader />;
  }

  return (
    <Fragment>
      {openInviteUserModal && isAuthorized && (
        <InviteUser isModalOpen={openInviteUserModal} closeModal={handleCloseInviteUserModal} />
      )}
      {isSignOutModalOpen && (
        <ConfirmModal
          title="Are you sure you want to logout from your account?"
          openConfirmModal={isSignOutModalOpen}
          onClose={closeSignOutModal}
          onSubmit={handleSignOut}
          submitText="Logout"
          type="error"
        />
      )}
      <Helmet>
        <title>htraction | Platform for Entrepreneurs | Startup showcase & funding</title>
        <meta
          name="description"
          content="A startup success platform: Validate your idea using AI, Showcase your idea & startup for feedback & funding, discover all the programs by incubators"
        />
        <meta name="robots" content="index, follow" />
        {/* Open Graph Tags */}
        <meta property="og:title" content="htraction | Platform for Entrepreneurs" />
        <meta
          property="og:description"
          content="A startup success platform: Validate your idea using AI, Showcase your idea & startup for feedback & funding, discover all the programs by incubators"
        />
        <meta
          name="keywords"
          content="startup platform, incubator programs, investors, funding, idea validation, pitch deck, entrepreneurship, startup showcase, accelerator, early-stage startups, htraction"
        />
        <meta property="og:image" content="https://htraction.com/ogimage.png?v=2" />
        <meta property="og:url" content="https://htraction.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="htraction" />

        {/* Twitter Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="htraction | Platform for Entrepreneurs" />
        <meta
          name="twitter:description"
          content="A startup success platform: Validate your idea using AI, Showcase your idea & startup for feedback & funding, discover all the programs by incubators"
        />
        <meta name="twitter:image" content="https://htraction.com/ogimage.png?v=2" />
      </Helmet>

      <ErrorBoundary>
        <Routes isAuthorized={isAuthorized} />
      </ErrorBoundary>
      <Popup />
    </Fragment>
  );
};

export default App;
